import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { resolveLaunchContext, syncLaunchContextToUrl } from "../../utilities/appSessionKey";

/**
 * Keeps launch query params on the address bar after in-app navigations
 * so browser refresh always rehydrates the correct tenant persist bucket.
 * Mount inside BrowserRouter (already true for App).
 */
export default function LaunchContextSync() {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const ctx = resolveLaunchContext();
    syncLaunchContextToUrl(ctx);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const unlisten = history.listen(() => {
      syncLaunchContextToUrl(resolveLaunchContext());
    });
    return unlisten;
  }, [history]);

  return null;
}
